import { createFileRoute } from '@tanstack/react-router'
import AddPage from '@/features/scenic/scenic-areas/pages/add'

export const Route = createFileRoute(
  '/_authenticated/(scenic)/scenic-areas/add'
)({ component: AddPage })
